import React from "react";
import AgentChat from "../../components/AgentChat";

export default function AnalyticsPage() {
  return <AgentChat />;
}
